{
  "version": 1,
  "asset_id": "759ac10b-385b-4107-a088-5cbca68d61a4",
  "project_id": "1820e758-46fa-46b0-bd5a-016534d0d263",
  "url": "/__l5e/assets-v1/759ac10b-385b-4107-a088-5cbca68d61a4/workspace-640.webp",
  "r2_key": "a/v1/1820e758-46fa-46b0-bd5a-016534d0d263/759ac10b-385b-4107-a088-5cbca68d61a4/workspace-640.webp",
  "original_filename": "workspace-640.webp",
  "size": 18244,
  "content_type": "image/webp",
  "created_at": "2026-07-25T02:27:05Z"
}
